import { Fragment, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { useEffect } from 'react';
import { noop } from 'shell/utils/noop';
import FormTownHall, { TownHallForm } from 'system/components/town-halls/form';
import { TownHall } from 'shell/models/town-hall';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonTownHallCrumbs } from '../constants';
import { CirculationArea } from 'shell/models/circulation-area';

const TownHallDetailPage = (): React.ReactElement => {
  const params = useParams();
  const {
    data,
    loading,
    error,
    get: getTownHall,
  } = useHttpFetch<HttpResponse<TownHall>>(`${__TOPONYMY_API_URL__}/municipi/${params.id}`, {
    data: {},
  });

  const {
    get: getCirculationArea,
    data: circulationArea,
    loading: loadingArea,
  } = useHttpFetch<HttpResponse<CirculationArea>>(`${__TOPONYMY_API_URL__}/areaCircolazione`);

  const townHallInitialValues: TownHallForm = useMemo(() => {
    const townhall = data?.payload;
    if (!townhall || !!error) {
      return {
        code: '',
        description: '',
        streetNumber: '',
        shortDescription: '',
        address: null,
        civicRepresentative: '',
      };
    }
    return {
      address: {
        code: circulationArea?.payload.key?.codice || 0,
        description: circulationArea?.payload.descrizionePostale || '',
      },
      shortDescription: townhall.descrizioneBreve,
      streetNumber: townhall.numeroCivico,
      code: townhall.key?.codice,
      description: townhall.descrizione,
      civicRepresentative: townhall.esponenteCivico,
    };
  }, [data, circulationArea]);

  const navigate = useNavigate();

  useEffect(() => {
    getTownHall().then((response) => {
      const serviceResponse = response as HttpResponse<TownHall>;
      getCirculationArea(serviceResponse.payload.areaCircolazione?.toString());
    });
  }, [params.id]);

  const loadingService = loading && !data && loadingArea && !circulationArea;

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonTownHallCrumbs, { name: 'Dettaglio Municipio' }]} />
      {loadingService ? null : (
        <FormTownHall
          title="Dettaglio Municipio"
          onOk={noop}
          onCancel={() => {
            navigate('/sistema/municipi');
          }}
          disabled
          initialValues={townHallInitialValues}
        />
      )}
    </Fragment>
  );
};

TownHallDetailPage.displayName = 'Town Hall Detail page component';

export default TownHallDetailPage;
